export default __webpack_public_path__ + "static/media/rabbit36.e6b115fb.gif";